import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Calendar, User, ArrowRight, Tag } from 'lucide-react';
import { useSEO } from '../../utils/seo';

export default function Blog() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Blog - ISO Belgelendirme ve Kalite Yönetimi Yazıları | IQCERT',
    description: 'Belgelendirme, denetim ve kalite yönetimi alanındaki en güncel bilgiler, uzman görüşleri ve sektörel gelişmeler hakkında yazılarımızı okuyun.',
    keywords: 'ISO blog, kalite yönetimi yazıları, belgelendirme rehberi, iş güvenliği makaleleri, enerji verimliliği',
    canonical: `${siteUrl}/blog`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      '@id': `${siteUrl}/blog#blog`,
      url: `${siteUrl}/blog`,
      name: 'IQCERT Blog',
      description: 'Belgelendirme, denetim ve kalite yönetimi hakkında uzman yazıları',
      publisher: {
        '@id': `${siteUrl}/#organization`
      },
      blogPost: [
        {
          '@type': 'BlogPosting',
          headline: 'ISO 9001:2015 Kalite Yönetim Sistemi: İşletmeniz İçin Neden Önemli?',
          description: 'ISO 9001:2015 standardı, işletmelerin kalite yönetim sistemlerini geliştirmelerine yardımcı olan uluslararası bir standarttır.',
          author: {
            '@type': 'Person',
            name: 'Dr. Mehmet Yılmaz'
          },
          datePublished: '2024-12-15',
          image: 'https://public.readdy.ai/ai/img_res/4fb2f88b9f70b7fcd95144916ab2afa7.jpg',
          publisher: {
            '@id': `${siteUrl}/#organization`
          }
        }
      ]
    }
  });

  const featuredPost = {
    id: 1,
    title: 'ISO 9001:2015 Kalite Yönetim Sistemi: İşletmeniz İçin Neden Önemli?',
    excerpt: 'ISO 9001:2015 standardı, işletmelerin kalite yönetim sistemlerini geliştirmelerine yardımcı olan uluslararası bir standarttır. Bu yazımızda ISO 9001\'in faydalarını ve uygulama sürecini detaylı olarak inceliyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20meeting%20room%20with%20business%20professionals%20discussing%20ISO%209001%20quality%20management%20system%2C%20charts%20and%20documents%20on%20table%2C%20professional%20corporate%20environment&width=800&height=400&seq=blog1&orientation=landscape',
    author: 'Dr. Mehmet Yılmaz',
    date: '15 Aralık 2024',
    category: 'Kalite Yönetimi',
    readTime: '8 dk okuma'
  };

  const blogPosts = [
    {
      id: 2,
      title: 'Sürdürülebilir Turizm Sertifikasyonu: Geleceğin Turizm Anlayışı',
      excerpt: 'Turizm sektöründe sürdürülebilirlik giderek daha önemli hale geliyor. GSTC standartları ile nasıl sürdürülebilir turizm sertifikası alabileceğinizi öğrenin.',
      image: 'https://readdy.ai/api/search-image?query=Sustainable%20tourism%20concept%20with%20eco-friendly%20hotel%2C%20green%20building%2C%20solar%20panels%2C%20natural%20landscape%2C%20environmental%20responsibility%20in%20hospitality%20industry&width=400&height=250&seq=blog2&orientation=landscape',
      author: 'Ayşe Demir',
      date: '12 Aralık 2024',
      category: 'Sürdürülebilirlik',
      readTime: '6 dk okuma'
    },
    {
      id: 3,
      title: 'İş Sağlığı ve Güvenliği: ISO 45001 Standardının Faydaları',
      excerpt: 'İş yerinde güvenliği sağlamak için ISO 45001 standardı nasıl uygulanır? İşçi sağlığı ve güvenliği yönetim sistemi hakkında bilmeniz gerekenler.',
      image: 'https://readdy.ai/api/search-image?query=Workplace%20safety%20concept%20with%20workers%20wearing%20safety%20equipment%2C%20hard%20hats%2C%20safety%20vests%2C%20industrial%20environment%2C%20occupational%20health%20and%20safety%20standards&width=400&height=250&seq=blog3&orientation=landscape',
      author: 'İng. Ahmet Kaya',
      date: '10 Aralık 2024',
      category: 'İş Güvenliği',
      readTime: '7 dk okuma'
    },
    {
      id: 4,
      title: 'Enerji Verimliliği ve ISO 50001: Maliyetleri Düşürmenin Yolu',
      excerpt: 'Enerji maliyetlerini azaltmak ve çevresel etkiyi minimize etmek için ISO 50001 enerji yönetim sistemi nasıl uygulanır?',
      image: 'https://readdy.ai/api/search-image?query=Energy%20efficiency%20concept%20with%20solar%20panels%2C%20wind%20turbines%2C%20LED%20lighting%2C%20smart%20building%20technology%2C%20sustainable%20energy%20management%20systems&width=400&height=250&seq=blog4&orientation=landscape',
      author: 'Fatma Özkan',
      date: '8 Aralık 2024',
      category: 'Enerji Yönetimi',
      readTime: '5 dk okuma'
    },
    {
      id: 5,
      title: 'Bilgi Güvenliği: ISO 27001 ile Verilerinizi Koruyun',
      excerpt: 'Dijital çağda bilgi güvenliği kritik önem taşıyor. ISO 27001 standardı ile bilgi güvenliği yönetim sistemi nasıl kurulur?',
      image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20with%20digital%20lock%2C%20data%20protection%2C%20secure%20servers%2C%20network%20security%2C%20information%20security%20management%20system&width=400&height=250&seq=blog5&orientation=landscape',
      author: 'Dr. Mehmet Yılmaz',
      date: '5 Aralık 2024',
      category: 'Bilgi Güvenliği',
      readTime: '9 dk okuma'
    },
    {
      id: 6,
      title: 'Çevre Yönetimi: ISO 14001 ile Sürdürülebilir İşletmecilik',
      excerpt: 'Çevresel etkilerinizi minimize etmek ve sürdürülebilir bir işletme modeli oluşturmak için ISO 14001 standardını nasıl uygulayabilirsiniz?',
      image: 'https://readdy.ai/api/search-image?query=Environmental%20management%20concept%20with%20green%20factory%2C%20recycling%20symbols%2C%20clean%20technology%2C%20sustainable%20manufacturing%2C%20eco-friendly%20business%20practices&width=400&height=250&seq=blog6&orientation=landscape',
      author: 'Ayşe Demir',
      date: '3 Aralık 2024',
      category: 'Çevre Yönetimi',
      readTime: '6 dk okuma'
    },
    {
      id: 7,
      title: 'Asansör Periyodik Kontrolü: Güvenlik ve Yasal Yükümlülükler',
      excerpt: 'Asansörlerin güvenli çalışması için periyodik kontroller neden önemli? Yasal yükümlülükler ve kontrol süreçleri hakkında bilgiler.',
      image: 'https://readdy.ai/api/search-image?query=Elevator%20maintenance%20and%20inspection%2C%20technician%20checking%20elevator%20systems%2C%20safety%20equipment%2C%20modern%20building%20elevator%20shaft%2C%20professional%20inspection%20process&width=400&height=250&seq=blog7&orientation=landscape',
      author: 'İng. Ahmet Kaya',
      date: '1 Aralık 2024',
      category: 'Teknik Kontroller',
      readTime: '4 dk okuma'
    }
  ];

  const categories = [
    'Tümü',
    'Kalite Yönetimi',
    'Sürdürülebilirlik',
    'İş Güvenliği',
    'Enerji Yönetimi',
    'Bilgi Güvenliği',
    'Çevre Yönetimi',
    'Teknik Kontroller'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-red-600 to-red-800 text-white py-20">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Blog</h1>
              <p className="text-xl leading-relaxed">
                Belgelendirme, denetim ve kalite yönetimi alanındaki en güncel bilgiler, 
                uzman görüşleri ve sektörel gelişmeler hakkında yazılarımızı okuyun.
              </p>
            </div>
          </div>
        </section>

        {/* Featured Post */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-8">Öne Çıkan Yazı</h2>
              <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="md:flex">
                  <div className="md:w-1/2">
                    <img 
                      src={featuredPost.image} 
                      alt={featuredPost.title}
                      className="w-full h-64 md:h-full object-cover object-top"
                    />
                  </div>
                  <div className="md:w-1/2 p-8">
                    <div className="flex items-center mb-4">
                      <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium">
                        {featuredPost.category}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">{featuredPost.title}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{featuredPost.excerpt}</p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4 text-sm text-gray-500">
                        <div className="flex items-center">
                          <User className="w-4 h-4 mr-1" />
                          {featuredPost.author}
                        </div>
                        <div className="flex items-center">
                          <Calendar className="w-4 h-4 mr-1" />
                          {featuredPost.date}
                        </div>
                        <span>{featuredPost.readTime}</span>
                      </div>
                      <button className="flex items-center text-red-600 hover:text-red-700 font-medium">
                        Devamını Oku
                        <ArrowRight className="w-4 h-4 ml-1" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Filter */}
        <section className="py-8 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className={`px-4 py-2 rounded-full transition-colors ${
                    index === 0 
                      ? 'bg-red-600 text-white' 
                      : 'bg-white text-gray-600 hover:bg-red-50 hover:text-red-600'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts Grid */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="p-6">
                    <div className="flex items-center mb-3">
                      <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium">
                        {post.category}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2">{post.title}</h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
                    <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                      <div className="flex items-center">
                        <User className="w-4 h-4 mr-1" />
                        {post.author}
                      </div>
                      <div className="flex items-center">
                        <Calendar className="w-4 h-4 mr-1" />
                        {post.date}
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-500">{post.readTime}</span>
                      <button className="flex items-center text-red-600 hover:text-red-700 font-medium">
                        Oku
                        <ArrowRight className="w-4 h-4 ml-1" />
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Blog Güncellemelerini Kaçırmayın</h2>
              <p className="text-gray-600 mb-8">
                Yeni yazılarımızdan haberdar olmak için e-posta listemize katılın. 
                Kalite yönetimi ve belgelendirme alanındaki en güncel bilgileri size ulaştıralım.
              </p>
              <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                <input
                  type="email"
                  placeholder="E-posta adresiniz"
                  className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                />
                <button className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap">
                  Abone Ol
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
